// 分类选择树
import React from 'react';
import { TreeSelect } from 'antd';

const {TreeNode} = TreeSelect;

function renderTreeNode(data) {
  return data.map(item => {
    if(item.children) {
      return (
        <TreeNode value={item.id} title={item.title} key={item.id}>
          {renderTreeNode(item.children)}
        </TreeNode>
      );
    }

    return (<TreeNode value={item.id} title={item.title} key={item.id}>{item.title}</TreeNode>);
  });
};

const ProductCategoryTreeSelect = ({
  productCategories,
  value,
  onChange,
  ...other
}) => {
  return (
    <TreeSelect
      value={value}
      onChange={onChange}
      // getPopupContainer={triggerNode => triggerNode.parentNode}
      placeholder="请选择商品类型"
      treeDefaultExpandAll={true}
      allowClear={true}
      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
      {...other}
    >
      {renderTreeNode(productCategories)}
    </TreeSelect>
  );
};

export default ProductCategoryTreeSelect;
